import { VenuePortalUser } from "@/graphql/operations";
import { gql } from "@apollo/client";

export type GetUserVenuesInput = {
  venuePortalUserId: string;
};
export type GetUserVenuesResponse = {
  venuePortalUser: Pick<VenuePortalUser, "id" | "venues" | "products">;
};

export const GET_USER_VENUES_QUERY = gql`
  query GetVenuePortalUserVenues($venuePortalUserId: ID) {
    venuePortalUser(id: $venuePortalUserId) {
      id
      products {
        id
        name
      }

      venues {
        id
        name

        products {
          id
          name
        }
      }
    }
  }
`;
